(function () {
  const fitAndChestSize = [
    { casualSize: "XS", chest: 84, trousers: 72 },
    { casualSize: "S", chest: 88, trousers: 76 },
    { casualSize: "M", chest: 92, trousers: 80 },
    { casualSize: "M", chest: 96, trousers: 84 },
    { casualSize: "L", chest: 100, trousers: 88 },
    { casualSize: "L", chest: 104, trousers: 92 },
    { casualSize: "XL", chest: 108, trousers: 96 },
    { casualSize: "XL", chest: 112, trousers: 100 },
    { casualSize: "XXL", chest: 116, trousers: 104 },
    { casualSize: "XXL", chest: 120, trousers: 108 },
    { casualSize: "3XL", chest: 124, trousers: 112 },
    { casualSize: "3XL", chest: 128, trousers: 116 },
  ];

  const waistSize = [
    { label: "76", cm: 76 },
    { label: "80", cm: 80 },
    { label: "84", cm: 84 },
    { label: "88", cm: 88 },
    { label: "92", cm: 92 },
    { label: "96", cm: 96 },
    { label: "100", cm: 100 },
    { label: "104", cm: 104 },
    { label: "108", cm: 108 },
    { label: "112", cm: 112 },
    { label: "116", cm: 116 },
  ];

  function jeansSizeFromInches(inches) {
    return { label: `${inches}`, cm: inchesToCm(inches) };
  }

  const jeansSize = [28, 30, 32, 34, 36, 38, 40, 42, 44].map(jeansSizeFromInches);

  const waistLimits = {
    waist: { minCm: 76, maxCm: 116, minIn: 29, maxIn: 46 },
    jeans: { minCm: 71, maxCm: 112, minIn: 28, maxIn: 44 },
  };

  const shirtSizeChart = [
    { casualSize: "S", shirtSize: 37 },
    { casualSize: "S", shirtSize: 38 },
    { casualSize: "M", shirtSize: 39 },
    { casualSize: "M", shirtSize: 40 },
    { casualSize: "L", shirtSize: 41 },
    { casualSize: "L", shirtSize: 42 },
    { casualSize: "XL", shirtSize: 43 },
    { casualSize: "XL", shirtSize: 44 },
    { casualSize: "XXL", shirtSize: 46 },
    { casualSize: "XXL", shirtSize: 48 },
    { casualSize: "XXL", shirtSize: 50 },
  ];

  function lbsToKg(lbs) {
    return lbs / 2.20462;
  }

  function inchesToCm(inches) {
    return inches * 2.54;
  }

  function feetAndInchesToCm(feet, inches) {
    return inchesToCm(feet * 12 + inches);
  }

  function weightToChestSize(weightKg) {
    const boundaries = {
      60: { lower: 84, upper: 88 },
      65: { lower: 88, upper: 92 },
      70: { lower: 92, upper: 92 },
      75: { lower: 96, upper: 96 },
      80: { lower: 96, upper: 100 },
      85: { lower: 100, upper: 104 },
      90: { lower: 104, upper: 108 },
      95: { lower: 108, upper: 112 },
      100: { lower: 112, upper: 116 },
      110: { lower: 116, upper: 120 },
      120: { lower: 120, upper: 124 },
      130: { lower: 124, upper: 128 },
    };

    if (boundaries[weightKg]) {
      return boundaries[weightKg].lower;
    }

    if (weightKg >= 55 && weightKg < 60) return 80;
    if (weightKg >= 60 && weightKg < 65) return 84;
    if (weightKg >= 65 && weightKg < 70) return 88;
    if (weightKg > 70 && weightKg < 75) return weightKg <= 72.5 ? 92 : 96;
    if (weightKg > 75 && weightKg < 80) return 92;
    if (weightKg > 80 && weightKg < 85) return 96;
    if (weightKg > 85 && weightKg < 90) return 100;
    if (weightKg > 90 && weightKg < 95) return 104;
    if (weightKg > 95 && weightKg < 100) return 108;
    if (weightKg > 100 && weightKg < 110) return 112;
    if (weightKg > 110 && weightKg < 120) return 116;
    if (weightKg > 120 && weightKg < 130) return 120;
    if (weightKg > 130 && weightKg <= 140) return 124;

    return -1;
  }

  function determineFitLength(heightCm) {
    if (heightCm < 173) return "Short";
    if (heightCm >= 173 && heightCm < 188) return "Regular";
    return "Long";
  }

  function calculateHeightConfidenceFactor(heightCm) {
    if (heightCm < 173) {
      const dist = 173 - heightCm;
      if (dist <= 3) return 10;
      if (dist <= 6) return 5;
      return 0;
    } else if (heightCm >= 173 && heightCm < 188) {
      const minDist = Math.min(heightCm - 173, 188 - heightCm);
      if (minDist <= 3) return 10;
      if (minDist <= 6) return 5;
      return 0;
    } else {
      const dist = heightCm - 188;
      if (dist <= 3) return 10;
      if (dist <= 6) return 5;
      return 0;
    }
  }

  function adjustFitAndChestSize(baseSize, preference) {
    const currentIndex = fitAndChestSize.findIndex(
      (item) =>
        item.chest === baseSize.chest && item.trousers === baseSize.trousers,
    );
    if (currentIndex === -1) return baseSize;

    if (preference === "easy") {
      if (currentIndex < fitAndChestSize.length - 1)
        return fitAndChestSize[currentIndex + 1];
      return baseSize;
    }
    if (preference === "regular") {
      return baseSize;
    }
    if (preference === "slim") {
      if (currentIndex > 0) return fitAndChestSize[currentIndex - 1];
      return baseSize;
    }
    return baseSize;
  }

  function calculateFitAndChestConfidence(
    actualChestCm,
    recommendedChestCm,
    heightCm,
    preference,
  ) {
    let confidence = 95;
    confidence -= Math.abs(actualChestCm - recommendedChestCm) * 3;
    confidence -= calculateHeightConfidenceFactor(heightCm);

    const sorted = [...fitAndChestSize].sort(
      (a, b) =>
        Math.abs(a.chest - actualChestCm) - Math.abs(b.chest - actualChestCm),
    );
    const naturalClosest = sorted[0]?.chest || actualChestCm;

    if (preference === "easy" && recommendedChestCm > naturalClosest)
      confidence -= 8;
    if (preference === "slim" && recommendedChestCm < naturalClosest)
      confidence -= 8;

    return Math.max(0, Math.min(95, Math.round(confidence)));
  }

  function findFitAndChestSize(chestCm, heightCm, preference) {
    const fit = determineFitLength(heightCm);
    const sorted = [...fitAndChestSize].sort(
      (a, b) => Math.abs(a.chest - chestCm) - Math.abs(b.chest - chestCm),
    );
    if (sorted.length === 0) return null;

    const regularSize = sorted[0];
    const adjustedSize = adjustFitAndChestSize(regularSize, preference);
    if (!adjustedSize) return null;

    const confidence = calculateFitAndChestConfidence(
      chestCm,
      adjustedSize.chest,
      heightCm,
      preference,
    );

    return {
      size: adjustedSize.casualSize,
      fit: fit,
      chestSize: adjustedSize.chest,
      trouserSize: adjustedSize.trousers,
      confidence: confidence,
    };
  }

  function adjustWaistSize(baseSize, preference, chart) {
    const currentIndex = chart.indexOf(baseSize);
    if (currentIndex === -1) return baseSize;

    if (preference === "easy") {
      if (currentIndex < chart.length - 1) return chart[currentIndex + 1];
      return baseSize;
    }
    if (preference === "regular") {
      return baseSize;
    }
    if (preference === "slim") {
      if (currentIndex > 0) return chart[currentIndex - 1];
      return baseSize;
    }
    return baseSize;
  }

  function calculateWaistConfidence(
    actualWaistCm,
    recommendedWaistCm,
    preference,
    chart,
  ) {
    let confidence = 95;
    confidence -= Math.abs(actualWaistCm - recommendedWaistCm) * 4;

    const sorted = [...chart].sort(
      (a, b) =>
        Math.abs(a.cm - actualWaistCm) - Math.abs(b.cm - actualWaistCm),
    );
    const naturalClosest = sorted[0]?.cm || actualWaistCm;

    if (preference === "easy" && recommendedWaistCm > naturalClosest)
      confidence -= 8;
    if (preference === "slim" && recommendedWaistCm < naturalClosest)
      confidence -= 8;

    return Math.max(0, Math.min(95, Math.round(confidence)));
  }

  function findWaistSize(waistCm, preference, chart) {
    const sorted = [...chart].sort(
      (a, b) => Math.abs(a.cm - waistCm) - Math.abs(b.cm - waistCm),
    );
    if (sorted.length === 0) return null;

    const regularSize = sorted[0];
    const adjustedSize = adjustWaistSize(regularSize, preference, chart);
    if (!adjustedSize) return null;

    const confidence = calculateWaistConfidence(
      waistCm,
      adjustedSize.cm,
      preference,
      chart,
    );

    return {
      size: adjustedSize.label,
      confidence: confidence,
    };
  }

  function adjustShirtSize(baseSize, preference) {
    const currentIndex = shirtSizeChart.findIndex(
      (item) =>
        item.shirtSize === baseSize.shirtSize &&
        item.casualSize === baseSize.casualSize,
    );
    if (currentIndex === -1) return baseSize;

    if (preference === "easy") {
      if (currentIndex < shirtSizeChart.length - 1)
        return shirtSizeChart[currentIndex + 1];
      return baseSize;
    }
    if (preference === "regular") {
      return baseSize;
    }
    if (preference === "slim") {
      if (currentIndex > 0) return shirtSizeChart[currentIndex - 1];
      return baseSize;
    }
    return baseSize;
  }

  function calculateShirtConfidence(
    actualNeckCm,
    recommendedNeckCm,
    preference,
  ) {
    let confidence = 95;
    confidence -= Math.abs(actualNeckCm - recommendedNeckCm) * 5;

    const sorted = [...shirtSizeChart].sort(
      (a, b) =>
        Math.abs(a.shirtSize - actualNeckCm) -
        Math.abs(b.shirtSize - actualNeckCm),
    );
    const naturalClosest = sorted[0]?.shirtSize || actualNeckCm;

    if (preference === "easy" && recommendedNeckCm > naturalClosest)
      confidence -= 8;
    if (preference === "slim" && recommendedNeckCm < naturalClosest)
      confidence -= 8;

    return Math.max(0, Math.min(95, Math.round(confidence)));
  }

  function findShirtSize(neckCm, preference) {
    const sorted = [...shirtSizeChart].sort(
      (a, b) => Math.abs(a.shirtSize - neckCm) - Math.abs(b.shirtSize - neckCm),
    );
    if (sorted.length === 0) return null;

    const regularSize = sorted[0];
    const adjustedSize = adjustShirtSize(regularSize, preference);
    if (!adjustedSize) return null;

    const confidence = calculateShirtConfidence(
      neckCm,
      adjustedSize.shirtSize,
      preference,
    );

    return { size: `${adjustedSize.shirtSize}`, confidence };
  }

  class SizeGuide {
    constructor(element, method) {
      this.element = element;
      this.categoryType = element.dataset.categoryType;
      const unitHost = element.matches(".size-guide")
        ? element
        : element.querySelector(".size-guide");
      this.unitSystem = unitHost?.dataset.unitSystem || "metric";
      this.method = method;
      this.state = {
        currentStep: 0,
        heightCm: null,
        weightKg: null,
        chestCm: null,
        waistCm: null,
        neckCm: null,
        preference: null,
        result: null,
      };
      this.steps = this.getSteps();
      this.init();
    }

    getSteps() {
      if (this.categoryType === "fit-chest") {
        return this.method === "easy"
          ? ["height", "weight", "preference", "result"]
          : ["height", "chest", "preference", "result"];
      }
      if (this.categoryType === "waist" || this.categoryType === "jeans") {
        return ["waist", "preference", "result"];
      }
      if (this.categoryType === "shirt") {
        return ["height", "weight", "preference", "result"];
      }
      if (this.categoryType === "business-shirt") {
        return ["neck", "preference", "result"];
      }
      return [];
    }

    init() {
      this.bindEvents();
      this.updateUnitVisibility();
      this.showStep(0);
    }

    bindEvents() {
      this.element
        .querySelectorAll(".size-guide__option[data-preference]")
        .forEach((btn) => {
          btn.addEventListener("click", () =>
            this.selectPreference(btn.dataset.preference),
          );
        });

      const backBtn = this.element.querySelector(".size-guide__nav-back");
      const nextBtn = this.element.querySelector(".size-guide__nav-next");

      if (backBtn) backBtn.addEventListener("click", () => this.prevStep());
      if (nextBtn) nextBtn.addEventListener("click", () => this.nextStep());

      this.element.querySelectorAll(".size-guide__restart").forEach((btn) => {
        btn.addEventListener("click", () => this.restart());
      });

      this.element.querySelectorAll(".size-guide__input").forEach((input) => {
        input.addEventListener("keypress", (e) => {
          if (e.key === "Enter") this.nextStep();
        });
      });
    }

    updateUnitVisibility() {
      this.element
        .querySelectorAll(".size-guide__input-group[data-unit]")
        .forEach((group) => {
          group.style.display =
            group.dataset.unit === this.unitSystem ? "" : "none";
        });
    }

    selectPreference(preference) {
      this.state.preference = preference;
      this.element
        .querySelectorAll(".size-guide__option[data-preference]")
        .forEach((btn) => {
          btn.classList.toggle(
            "size-guide__option--selected",
            btn.dataset.preference === preference,
          );
        });
      this.calculateAndShowResult();
    }

    getCurrentStepName() {
      return this.steps[this.state.currentStep];
    }

    showStep(index) {
      this.state.currentStep = index;
      const stepName = this.getCurrentStepName();

      this.element.querySelectorAll(".size-guide__step").forEach((step) => {
        step.classList.remove("size-guide__step--active");
      });

      const activeStep = this.element.querySelector(
        `.size-guide__step[data-step="${stepName}"]`,
      );
      if (activeStep) {
        activeStep.classList.add("size-guide__step--active");
        const input = activeStep.querySelector(
          `.size-guide__input-group[data-unit="${this.unitSystem}"] .size-guide__input`,
        );
        if (input) setTimeout(() => input.focus(), 100);
      }

      this.updateNavigation();
      this.updateProgress();
    }

    updateNavigation() {
      const backBtn = this.element.querySelector(".size-guide__nav-back");
      const nextBtn = this.element.querySelector(".size-guide__nav-next");
      const stepName = this.getCurrentStepName();

      if (backBtn) {
        backBtn.style.display = this.state.currentStep === 0 ? "none" : "";
      }

      if (nextBtn) {
        const isResultStep = stepName === "result";
        const isPreferenceStep = stepName === "preference";
        nextBtn.style.display = isResultStep || isPreferenceStep ? "none" : "";
      }
    }

    updateProgress() {
      const progressBar = this.element.querySelector(
        ".size-guide__progress-bar",
      );
      if (progressBar) {
        const progress =
          ((this.state.currentStep + 1) / this.steps.length) * 100;
        progressBar.style.width = `${progress}%`;
      }
    }

    validateCurrentStep() {
      const stepName = this.getCurrentStepName();
      const activeGroup = this.element.querySelector(
        `.size-guide__step[data-step="${stepName}"] .size-guide__input-group[data-unit="${this.unitSystem}"]`,
      );
      const errorEl = activeGroup?.querySelector(".size-guide__error");

      const showError = (msg) => {
        if (errorEl) errorEl.textContent = msg;
        return false;
      };
      const clearError = () => {
        if (errorEl) errorEl.textContent = "";
        return true;
      };

      if (stepName === "height") {
        const heightCm = this.getHeightCm();
        if (!heightCm) return showError("Please enter your height");
        if (this.unitSystem === "metric") {
          if (heightCm < 155) return showError("Height must be at least 155cm");
          if (heightCm > 201)
            return showError("Height must be no more than 201cm");
        } else {
          if (heightCm < 155) return showError("Height must be at least 5 ft 1 in");
          if (heightCm > 201)
            return showError("Height must be no more than 6 ft 7 in");
        }
        this.state.heightCm = heightCm;
        return clearError();
      }

      if (stepName === "weight") {
        const weightKg = this.getWeightKg();
        if (!weightKg) return showError("Please enter your weight");
        if (this.unitSystem === "metric") {
          if (weightKg < 55) return showError("Weight must be at least 55kg");
          if (weightKg > 140)
            return showError("Weight must be no more than 140kg");
        } else {
          if (weightKg < 55) return showError("Weight must be at least 121lbs");
          if (weightKg > 140)
            return showError("Weight must be no more than 309lbs");
        }
        this.state.weightKg = weightKg;
        return clearError();
      }

      if (stepName === "chest") {
        const chestCm = this.getChestCm();
        if (!chestCm) return showError("Please enter your chest measurement");
        if (this.unitSystem === "metric") {
          if (chestCm < 84) return showError("Chest must be at least 84cm");
          if (chestCm > 128)
            return showError("Chest must be no more than 128cm");
        } else {
          if (chestCm < 84) return showError("Chest must be at least 33 in");
          if (chestCm > 128) return showError("Chest must be no more than 50 in");
        }
        this.state.chestCm = chestCm;
        return clearError();
      }

      if (stepName === "waist") {
        const waistCm = this.getWaistCm();
        if (!waistCm) return showError("Please enter your waist measurement");
        const limits = waistLimits[this.categoryType] || waistLimits.waist;
        if (this.unitSystem === "metric") {
          if (waistCm < limits.minCm)
            return showError(`Waist must be at least ${limits.minCm}cm`);
          if (waistCm > limits.maxCm)
            return showError(`Waist must be no more than ${limits.maxCm}cm`);
        } else {
          if (waistCm < limits.minCm)
            return showError(`Waist must be at least ${limits.minIn} in`);
          if (waistCm > limits.maxCm)
            return showError(`Waist must be no more than ${limits.maxIn} in`);
        }
        this.state.waistCm = waistCm;
        return clearError();
      }

      if (stepName === "neck") {
        const neckCm = this.getNeckCm();
        if (!neckCm) return showError("Please enter your neck measurement");
        if (this.unitSystem === "metric") {
          if (neckCm < 37) return showError("Neck must be at least 37cm");
          if (neckCm > 50) return showError("Neck must be no more than 50cm");
        } else {
          if (neckCm < 37) return showError("Neck must be at least 14 in");
          if (neckCm > 50) return showError("Neck must be no more than 20 in");
        }
        this.state.neckCm = neckCm;
        return clearError();
      }

      return true;
    }

    getStepEl(stepName) {
      return this.element.querySelector(`.size-guide__step[data-step="${stepName}"]`);
    }

    getHeightCm() {
      const step = this.getStepEl("height");
      if (!step) return null;
      if (this.unitSystem === "metric") {
        return parseFloat(step.querySelector('[data-unit="metric"] .size-guide__input')?.value) || null;
      }
      const imperialEl = step.querySelector('[data-unit="imperial"]');
      const inputs = imperialEl?.querySelectorAll(".size-guide__input");
      const feet = parseFloat(inputs?.[0]?.value) || 0;
      const inches = parseFloat(inputs?.[1]?.value) || 0;
      return feet || inches ? feetAndInchesToCm(feet, inches) : null;
    }

    getWeightKg() {
      const step = this.getStepEl("weight");
      if (!step) return null;
      if (this.unitSystem === "metric") {
        return parseFloat(step.querySelector('[data-unit="metric"] .size-guide__input')?.value) || null;
      }
      const lbs = parseFloat(step.querySelector('[data-unit="imperial"] .size-guide__input')?.value) || null;
      return lbs ? lbsToKg(lbs) : null;
    }

    getChestCm() {
      const step = this.getStepEl("chest");
      if (!step) return null;
      if (this.unitSystem === "metric") {
        return parseFloat(step.querySelector('[data-unit="metric"] .size-guide__input')?.value) || null;
      }
      const inches = parseFloat(step.querySelector('[data-unit="imperial"] .size-guide__input')?.value) || null;
      return inches ? inchesToCm(inches) : null;
    }

    getWaistCm() {
      const step = this.getStepEl("waist");
      if (!step) return null;
      if (this.unitSystem === "metric") {
        return parseFloat(step.querySelector('[data-unit="metric"] .size-guide__input')?.value) || null;
      }
      const inches = parseFloat(step.querySelector('[data-unit="imperial"] .size-guide__input')?.value) || null;
      return inches ? inchesToCm(inches) : null;
    }

    getNeckCm() {
      const step = this.getStepEl("neck");
      if (!step) return null;
      if (this.unitSystem === "metric") {
        return parseFloat(step.querySelector('[data-unit="metric"] .size-guide__input')?.value) || null;
      }
      const inches = parseFloat(step.querySelector('[data-unit="imperial"] .size-guide__input')?.value) || null;
      return inches ? inchesToCm(inches) : null;
    }

    nextStep() {
      if (!this.validateCurrentStep()) return;
      if (this.state.currentStep < this.steps.length - 1) {
        this.showStep(this.state.currentStep + 1);
      }
    }

    prevStep() {
      if (this.state.currentStep > 0) {
        this.showStep(this.state.currentStep - 1);
      }
    }

    calculateAndShowResult() {
      let result = null;
      let outOfRange = false;

      if (this.categoryType === "fit-chest") {
        let chestCm = this.state.chestCm;
        if (this.method === "easy" && this.state.weightKg) {
          chestCm = weightToChestSize(this.state.weightKg);
          if (chestCm === -1) {
            outOfRange = true;
          }
        }
        if (!outOfRange && chestCm) {
          result = findFitAndChestSize(
            chestCm,
            this.state.heightCm,
            this.state.preference,
          );
        }
      } else if (this.categoryType === "waist" || this.categoryType === "jeans") {
        if (this.state.waistCm) {
          result = findWaistSize(
            this.state.waistCm,
            this.state.preference,
            this.categoryType === "jeans" ? jeansSize : waistSize,
          );
        }
      } else if (this.categoryType === "shirt") {
        const chestCm = weightToChestSize(this.state.weightKg);
        if (chestCm === -1) {
          outOfRange = true;
        } else {
          const fitResult = findFitAndChestSize(
            chestCm,
            this.state.heightCm,
            this.state.preference,
          );
          if (fitResult) {
            result = {
              size: fitResult.size === "XS" ? "S" : fitResult.size,
              confidence: fitResult.confidence,
            };
          }
        }
      } else if (this.categoryType === "business-shirt") {
        if (this.state.neckCm) {
          result = findShirtSize(this.state.neckCm, this.state.preference);
        }
      }

      this.state.result = result;
      this.displayResult(result, outOfRange);
      this.nextStep();
    }

    displayResult(result, outOfRange) {
      const resultEl = this.element.querySelector(
        ".size-guide__result:not(.size-guide__result--mtm)",
      );
      const mtmEl = this.element.querySelector(".size-guide__result--mtm");

      if (!result || outOfRange) {
        if (resultEl) resultEl.style.display = "none";
        if (mtmEl) mtmEl.style.display = "";
        return;
      }

      if (resultEl) resultEl.style.display = "";
      if (mtmEl) mtmEl.style.display = "none";

      const sizeEl = this.element.querySelector(".size-guide__result-size");
      if (sizeEl) {
        if (this.categoryType == 'fit-chest') {
          sizeEl.textContent = `${result.chestSize} / ${result.fit}`;
        } else {
          sizeEl.textContent = result.size;
        }
      }

      if (result.fit) {
        const fitEl = this.element.querySelector(
          '[data-result="fit"] .size-guide__result-item-value',
        );
        if (fitEl) fitEl.textContent = result.fit;
      }

      if (result.chestSize) {
        const chestEl = this.element.querySelector(
          '[data-result="chest"] .size-guide__result-item-value',
        );
        if (chestEl) chestEl.textContent = `${result.chestSize}`;
      }

      if (result.trouserSize) {
        const trouserEl = this.element.querySelector(
          '[data-result="trouser"] .size-guide__result-item-value',
        );
        if (trouserEl) trouserEl.textContent = result.trouserSize;
      }

      const confidenceEl = this.element.querySelector(
        '[data-result="confidence"] .size-guide__result-item-value',
      );
      if (confidenceEl) {
        const displayConfidence = Math.min(result.confidence, 95);
        confidenceEl.textContent = `${displayConfidence}%`;
      }
    }

    restart() {
      this.state = {
        currentStep: 0,
        heightCm: null,
        weightKg: null,
        chestCm: null,
        waistCm: null,
        neckCm: null,
        preference: null,
        result: null,
      };

      this.element.querySelectorAll(".size-guide__input").forEach((input) => {
        input.value = "";
      });

      this.element
        .querySelectorAll(".size-guide__option--selected")
        .forEach((btn) => {
          btn.classList.remove("size-guide__option--selected");
        });

      this.element.querySelectorAll(".size-guide__error").forEach((el) => {
        el.textContent = "";
      });

      this.showStep(0);
    }
  }

  window.SizeGuide = SizeGuide;
})();
